<template>
    <div class="home_main" style="margin-top: -100px;">
        <div class="home_pic">
            <!-- <TopNav class="top-nav" /> -->
            <div class="pic-container">
                <el-image :src="blhcImageCopy(`ContactUs.png`)" alt="" class="full-bg-image" />
            </div>
        </div>
        <div class="blue-limit-wrapper">
            <div class="red-content-container">
                <section class="section-block intro-section">
                    <el-row :gutter="60">
                        <el-col :xs="24" :sm="12" :md="10" :lg="10" class="mb-mobile">
                            <div class="image-wrapper">
                                <img :src="blhcImageCopy('20251211pic.png')"
                                    alt="Interior Design" class="responsive-img" />
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="14" :lg="14">
                            <h2 class="main-title" style="margin: 40px 0 30px;">WHY CHOOSE ALY HOME?</h2>
                            <div class="feature-list">
                                <div class="feature-item" v-for="(item, index) in features" :key="index">
                                    <div class="feature-border"></div>
                                    <div class="feature-content">
                                        <h3 class="sub-title">{{ item.title }}</h3>
                                        <p class="desc-text">{{ item.desc }}</p>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </section>

                <div class="spacer"></div>

                <section class="section-block benefits-section">
                    <div class="text-center mb-60">
                        <h2 class="main-title centered">
                            CHOOSING ALY HOME MEANS GAINING MORE<br>THAN A PRODUCT; IT MEANS SECURING
                        </h2>
                    </div>

                    <el-row :gutter="40" class="benefit-row">
                        <el-col :xs="24" :sm="8" :md="8" class="mb-mobile">
                            <div class="benefit-item">
                                <h4 class="small-caps-title">PEACE OF MIND</h4>
                                <p class="desc-text">International certifications safeguard your business.</p>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8" class="mb-mobile">
                            <div class="benefit-item">
                                <h4 class="small-caps-title">OPERATIONAL EFFICIENCY</h4>
                                <p class="desc-text">Scalable production ensures a stable supply.</p>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <div class="benefit-item">
                                <h4 class="small-caps-title">A TRUE PARTNERSHIP</h4>
                                <p class="desc-text">A professional team provides comprehensive support.</p>
                            </div>
                        </el-col>
                    </el-row>
                </section>

                <section class="section-block contact-section">
                    <div class="contact-card">
                        <h2 class="main-title centered mb-50">
                            Contact us today and experience the ALY HOME difference
                        </h2>

                        <el-row :gutter="80">
                            <el-col :xs="24" :sm="10" :md="10" class="mb-mobile">

                                <div class="contact-details">
                                    <el-col :xs="24" :sm="24" :md="24">
                                        <div class="detail-group">
                                            <h4 class="group-title">General Inquiries</h4>
                                            <div class="icon-row">
                                                <i class="el-icon-phone"></i>
                                                <span>+86-574-62130152<br>13345950296</span>
                                            </div>
                                            <div class="icon-row">
                                                <i class="el-icon-message"></i>
                                                <span>service@alyhomeus.com</span>
                                            </div>
                                        </div>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="24">
                                        <div class="detail-group mt-40">
                                            <h4 class="group-title">Our Location</h4>
                                            <div class="icon-row">
                                                <i class="el-icon-location-outline"></i>
                                                <span>Aly Home, No. 23, Ruhu West Road,<br>Simen, Yuyao, Ningbo,
                                                    China.</span>
                                            </div>
                                        </div>
                                    </el-col>

                                </div>
                            </el-col>

                            <el-col :xs="24" :sm="14" :md="14">
                                <div class="form-area">
                                    <h4 class="group-title" style="margin-left: 0;">Request Information</h4>
                                    <el-form :model="form" size="medium" class="custom-form" ref="form" :rules="rules">
                                        <el-row :gutter="20">
                                            <el-col :xs="24" :sm="12">
                                                <el-form-item prop="userName">
                                                    <el-input v-model="form.userName"
                                                        placeholder="Your Name"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :xs="24" :sm="12">
                                                <el-form-item prop="email">
                                                    <el-input v-model="form.email" placeholder="Your Email"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>

                                        <el-form-item prop="content">
                                            <el-input type="textarea" :rows="6"
                                                placeholder="Please Inform Us Of Your Requirements"
                                                v-model="form.content">
                                            </el-input>
                                        </el-form-item>

                                        <el-form-item class="form-btn">
                                            <el-button class="submit-btn" @click="submitForm('form')">SUBMIT</el-button>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </section>

            </div>

        </div>
    </div>
</template>

<script>
import { informationOperation } from "@/api/goods";
// import TopNav from "@/components/TopNav.vue";
import { blhcImageCopy } from '@/utils/imageUtil';
import utils from '@/utils/util.js';
import { mapState } from "vuex";
export default {
    name: "Home",
    // components: {
    //     TopNav,
    // },
    data() {
        return {
            websiteImg: utils.websiteImg,
            form: {
                userName: '',
                email: '',
                content: ''
            },
            rules: {
                userName: [
                    { required: true, message: 'Please input your name', trigger: 'blur' }
                ],
                email: [
                    { required: true, message: 'Please input your email', trigger: 'blur' }
                ],
                content: [
                    { required: true, message: 'Please input your content', trigger: 'blur' }
                ]
            },
            features: [
                { title: "BECAUSE EXCELLENCE IS IN THE DETAILS.", desc: "When choosing a window decor supplier in the global market, you need more than just a manufacturer; you need a reliable strategic partner. ALY HOME is that trusted choice." },
                { title: "GLOBALLY CERTIFIED EXCELLENCE", desc: `We are committed to "Zero-Defect Quality." Every product meets stringent international standards and is certified by leading authorities like TUV and SGS. This is our benchmark and our promise to your customers.`},
                { title: "PROVEN SCALABILITY & RELIABILITY", desc: "With a 30,000+ sqm production base and a new facility under construction, we guarantee massive production capacity and on-time delivery, meeting needs from retail to large-scale projects." },
                { title: "ESTABLISHED GLOBAL EXPERIENCE", desc: `Our products have successfully served over 80 countries and regions. We possess a deep understanding of the standards and aesthetics of key markets like North America and Europe, offering you best-selling, "localized" products.` },
                { title: "END-TO-END EXPERTISE", desc: "From our R&D team of 60+ technical specialists to the lean 6S management integrated into every production step, we ensure perfection in every detail, from concept to completion." }
            ]
        };
    },
    computed: {
    ...mapState({
      user: state => state.user.user
    }),
    userInfo() {
      if (!this.user) return {}; // state.user.user 为空时返回空对象
      try {
        return typeof this.user === 'string' ? JSON.parse(this.user) : this.user;
      } catch (e) {
        return {};
      }
    },
    userEmail() {
      return this.userInfo.email || ''; // 核心判断依据
    },
},
    methods: {
        blhcImageCopy,
        submitForm(formName) {
            this.form.loginEmail = this.userEmail;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    informationOperation(this.form).then(res => {
                        if (res.code == 1) {
                            this.$message.success("Message Sent Successfully!");
                            this.form = {
                                userName: '',
                                email: '',
                                content: '',
                                loginEmail:""
                            };
                        } else {
                            this.$message.error(res.message || "Message Sent Failed!");
                        }
                    });
                }
            })
        }
    }
};
</script>
<style scoped>
.home_main {
    width: 100%;
    height: 100%;
}

.full-bg-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.home_pic {
    width: 100%;
    height: 100%;
    position: relative;
    line-height: 0;
}

.pic-container {
    width: 100%;
    height: 100vh;
    position: relative;
    line-height: 0;
    overflow: hidden;
}

.home_pic img {
    width: 100%;
    display: block;
}

.home_pic .el-image {
    width: 100%;
    display: block;
    line-height: 0;
}

.top-nav {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
}

.content {
    width: 100%;
    height: 100%;
    padding: 80px;
    box-sizing: border-box;
    background: #FAF9F7;
}
</style>
<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Lato:wght@400;700&display=swap');

// 变量定义
$font-serif: "NotoSerif", sans-serif;
$color-bg: #FAF9F7;
$color-text-main: #1a1a1a;
$color-text-sub: #555;
$color-accent: #c4b39b;
$color-btn: #4a453e;
$blue-box-width: 1920px;
$red-box-width: 1760px;

// 核心容器布局
.blue-limit-wrapper {
    width: 100%;
    max-width: $blue-box-width;
    margin: 0 auto;
    background-color: $color-bg;
    overflow-x: hidden;
    font-family: $font-serif;
    color: $color-text-main;
}

.red-content-container {
    width: 100%;
    max-width: $red-box-width;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
}

// 通用排版样式
.section-block {
    padding: 60px 0;
}

.main-title {
    font-family: $font-serif;
    font-size: 26px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 30px;
    line-height: 1.4;

    &.centered {
        text-align: center;
    }
}

.sub-title {
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 20px;
    letter-spacing: 0.5px;
}

.small-caps-title {
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 12px;
}

.desc-text {
    font-size: 16px;
    line-height: 1.8;
    color: $color-text-sub;
}

.text-center {
    text-align: center;
}

.mb-60 {
    margin-bottom: 60px;
}

.mb-50 {
    margin-bottom: 50px;
}

.mt-40 {
    margin-top: 40px;
}

// 第一部分：列表样式
.image-wrapper {
    width: 100%;
    height: 100%;
    min-height: 400px;
    background-color: #ddd;

    .responsive-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
}

.feature-list {
    .feature-item {
        display: flex;
        margin-bottom: 30px;
        position: relative;
        padding-left: 20px;

        .feature-border {
            width: 3px;
            background-color: #E7E3D8;
            margin-right: 20px;
            flex-shrink: 0;
            position: absolute;
            left: 0;
            top: 0;
            height: 20px;
        }

        .feature-content {
            padding-bottom: 5px;
        }
    }
}

// 第二部分：优势
.spacer {
    height: 1px;
    width: 100%;
    background-color: #e5e5e5;
    margin: 40px 0;
}

// 第三部分：联系我们
.contact-section {
    padding-bottom: 80px;
}

.contact-card {
    background-color: #fff;
    padding: 60px 80px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.03);
}

.group-title {
    font-weight: 700;
    margin-bottom: 40px;
    font-size: 20px;
    margin-left: 52px;
}

.icon-row {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 16px;
    color: #333;

    i {
        font-size: 24px;
        margin-right: 30px;
        color: #888;
        margin-top: 2px;
    }
}

// 表单样式重写 ElementUI
.custom-form {

    ::v-deep .el-input__inner,
    ::v-deep .el-textarea__inner {
        border-radius: 0;
        border-color: #ddd;
        background-color: #fff;
        font-family: $font-serif;

        &:focus {
            border-color: $color-btn;
        }
    }
}

.submit-btn {
    background-color: $color-btn;
    color: #fff;
    border: none;
    border-radius: 0;
    padding: 12px 35px;
    font-size: 12px;
    letter-spacing: 1px;
    text-transform: uppercase;
    transition: background 0.3s;

    &:hover {
        background-color: darken($color-btn, 10%);
        color: #fff;
    }
}

.benefit-row {
    text-align: center !important;
}

.contact-details {
    margin-left: 15%;
}

// 响应式媒体查询
@media (max-width: 768px) {
    .mb-mobile {
        margin-bottom: 30px;
    }

    .contact-details {
        margin-left: 0 !important;
    }

    .contact-card {
        padding: 40px 20px;
    }
  
    .sub-title ,.small-caps-title, .main-title{
        font-size: 4rem !important;
    }
    .desc-text ,.group-title,.icon-row{
        font-size: 3rem !important;
    }

    .group-title {
        margin-left: 0;
        font-size: 18px;
    }

    .form-btn {
        text-align: center;
    }
    .submit-btn{
       padding: 3rem 5rem !important;
    }
    .pic-container{
    width: 100%;
    height: 100%;
  }
}
</style>